import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var DealReportInterval;
(function (DealReportInterval) {
    DealReportInterval["TODAY"] = "TODAY";
    DealReportInterval["LAST_7_DAYS"] = "LAST_7_DAYS";
    DealReportInterval["LAST_30_DAYS"] = "LAST_30_DAYS";
    DealReportInterval["LAST_90_DAYS"] = "LAST_90_DAYS";
    DealReportInterval["LAST_180_DAYS"] = "LAST_180_DAYS";
    DealReportInterval["YTD"] = "YTD";
})(DealReportInterval || (DealReportInterval = {}));
export var DealProvider;
(function (DealProvider) {
    DealProvider["ALL"] = "ALL";
    DealProvider["XANDR"] = "XANDR";
    DealProvider["GOOGLE"] = "GOOGLE";
})(DealProvider || (DealProvider = {}));
